import { DataBean } from "../DataBean";

export class RequesItemConstants extends DataBean {


    public async getCashRequesItemConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCashRequesItemConstants_Number", [id]);
    }

}